import { render, staticRenderFns } from "./ResizeBar.vue?vue&type=template&id=84b886fe&scoped=true&"
import script from "./ResizeBar.vue?vue&type=script&lang=js&"
export * from "./ResizeBar.vue?vue&type=script&lang=js&"
import style0 from "./ResizeBar.vue?vue&type=style&index=0&id=84b886fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b886fe",
  null
  
)

component.options.__file = "www/vues/client/projectdisplay/ResizeBar.vue"
export default component.exports